<template>
  <main id="clientAbout" v-if="config.status.authed">
    <v-tabs grow icons-and-text
      v-model="store.tabPos"
      background-color="transparent"
      color="secondary">
      <v-tab v-for="item in authedNavigation" :key="item.path" :to="item.path">
        {{ item.meta.label }}
        <v-icon small>{{ item.meta.icon.join(' ') }}</v-icon>
      </v-tab>
    </v-tabs>
    <v-divider class="mb-4"></v-divider>
    <router-view
      ref="content"
      class="content"
      @emit="emitted"
    />
    <v-footer fixed inset app
      height="auto"
      color="white"
      class="pa-2">
      <v-row dense>
        <v-btn v-if="isEditing" text
          color="secondary white--text"
          @click="close">
          <v-icon small class="mr-1">fal fa-times</v-icon>閉じる
        </v-btn>
        <v-btn depressed outlined
          v-if="!isEditing"
          color="blue-grey darken-4"
          class="mr-4"
          @click="openPublisher">
          <v-icon small class="mr-1">fal fa-address-card</v-icon>補足情報書を確認する
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed
          v-if="!isEditing"
          color="secondary"
          :loading="isLoading"
          @click="edit">
          <v-icon small class="mr-1">fal fa-pencil</v-icon>編集する
        </v-btn>
        <v-btn depressed
          v-if="isEditing"
          color="secondary"
          :loading="isLoading"
          :disabled="$refs.content == null || !$refs.content.isValid"
          @click="submit">
          <v-icon small>fal fa-check</v-icon>&nbsp;保存する
        </v-btn>
      </v-row>
    </v-footer>
    <ClientBackgroundsPublisher ref="publisher" />
  </main>
</template>

<script>
import ClientAboutRoutes from '@/router/client/about'
import ClientBackgroundsPublisher from './modals/publish'
export default {
  name: 'clientAbout',
  components: {
    ClientBackgroundsPublisher
  },
  data () {
    return {
      config: {
        status: {
          loading: true,
          editing: false,
          authed: false
        }
      },
      store: {
        tabPos: null
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init: function () {
      this.auth()
    },
    auth: function () {
      let auths = this.$store.getters['author/get']('authority')
      let permit = this.$route.meta.permit
      if (!auths.includes(permit)) {
        this.$router.push('/')
      } else {
        this.$set(this.config.status, 'authed', true)
      }
    },
    state: function (req) {
      const { type, status } = req || {}
      if (type && status != null && this.config.status[type] != null) {
        this.$set(this.config.status, type, status)
      }
    },
    edit: function () {
      this.$refs.content.prepare()
    },
    submit: function () {
      this.$refs.content.submit()
    },
    close: function () {
      this.$set(this.config.status, 'editing', false)
      this.$refs.content.close()
    },
    openPublisher: function () {
      if (this.$refs.publisher) {
        this.$refs.publisher.open()
      }
    },
    emitted: function (req) {
      if (
        req &&
        req.action &&
        typeof this[req.action] === 'function'
      ) {
        this[req.action](req.data)
      }
    }
  },
  computed: {
    isLoading () {
      return !!this.config.status.loading
    },
    isEditing () {
      return !!this.config.status.editing
    },
    isDeveloping () {
      return this.$store.getters['author/get']('dev')
    },
    authedNavigation () {
      const cid = this.$route.params.id
      return ClientAboutRoutes.routes.map(rt => {
        return Object.assign({}, rt, {
          path: `/client/${cid}/about/${rt.path}`
        })
      })
    }
  }
}
</script>

<style lang="scss">
#clientAbout {
  .it-hv {
    user-select: auto;
  }
}
// #clientAbout {
//   position: relative;
//   .content {
//     position: relative;
//     width: 100%;
//     height: calc(100% - 72px);
//     z-index: 0;
//     background: $white;
//     .abt-item {
//       max-width: 700px;
//       margin: 0 auto;
//     }
//   }
// }
// @media screen and (max-width: $lg_screen_w) {
//   #clientAbout {
//     .content {
//       .abt-items {
//         &.multi {
//           display: block;
//           max-width: 700px;
//           .abt-column {
//             width: 100%;
//             margin: 0 auto;
//             &:first-of-type {
//               border-bottom: 1px solid $bb_c;
//             }
//           }
//         }
//       }
//     }
//   }
// }
</style>
